module.exports.moveCursorToEnd = (el) ->
  return if not el?
  value = el.value
  el.focus()
  el.value = ''
  el.value = value

module.exports.isValidEmail = (email) ->
  # use the more practical regex of RFC 5322 http://www.regular-expressions.info/email.html
  re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
  re.test(email)

module.exports.makeOnEnterKeyHandler = (callback) ->
  (event) ->
    if event.key is 'Enter'
      callback()

module.exports.makeOnCommandEnterKeyHandler = (callback) ->
  (event) ->
    if event.key is 'Enter' and event.getModifierState('Meta')
      callback()




// WEBPACK FOOTER //
// ./node_modules/shared-web/src/helpers/InputHelpers.coffee